import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import { api, money, errMsg } from "@/lib/api";

const STATUSES = ["Awaiting payment", "Paid", "Processing", "Shipped", "Delivered", "Cancelled", "Refunded"];

export default function OrdersTab() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);
  const update = async (o, status) => {
    try { await api.put(`/admin/orders/${o.order_number}`, { status }); toast.success("Order updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!orders.length) return <p data-testid="admin-orders-empty" className="text-sm text-[var(--mm-muted)]">No orders yet.</p>;
  return (
    <div data-testid="admin-orders-tab" className="space-y-4">
      {orders.map((o) => (
        <div key={o.order_number} data-testid={`admin-order-${o.order_number}`} className="border border-[var(--mm-line)] p-5 grid sm:grid-cols-12 gap-4">
          <div className="sm:col-span-3">
            <p className="font-serif-mm text-2xl">{o.order_number}</p>
            <p className="text-xs text-[var(--mm-muted)]">{new Date(o.created_at).toLocaleString("en-GB")}</p>
            <p className={`eyebrow mt-2 ${o.payment_status === "paid" ? "text-[var(--mm-red)]" : "text-[var(--mm-muted)]"}`}>{o.payment_status === "paid" ? "Paid" : "Unpaid"}</p>
          </div>
          <div className="sm:col-span-4 text-sm">
            {o.items.map((it, i) => <p key={i}>{it.quantity} × {it.name} — {it.size}{it.colour ? ` / ${it.colour}` : ""}</p>)}
            <p className="font-semibold mt-1">{money(o.total)}</p>
          </div>
          <div className="sm:col-span-3 text-xs leading-relaxed">
            <p className="font-semibold">{o.customer.first_name} {o.customer.last_name}</p>
            <p>{o.customer.email}{o.customer.phone ? ` · ${o.customer.phone}` : ""}</p>
            <p>{o.customer.address1}{o.customer.address2 ? `, ${o.customer.address2}` : ""}, {o.customer.city}, {o.customer.postcode}, {o.customer.country}</p>
          </div>
          <div className="sm:col-span-2">
            <select data-testid={`admin-order-status-${o.order_number}`} value={o.status} onChange={(e) => update(o, e.target.value)} className="w-full text-xs border border-[var(--mm-line)] bg-transparent p-2">
              {STATUSES.map((s) => <option key={s}>{s}</option>)}
            </select>
            <div className="flex flex-wrap gap-1.5 mt-3">
              {[["slip", "Packing slip"], ["invoice", "Invoice"], ["label", "Label"]].map(([k, l]) => (
                <a key={k} data-testid={`admin-order-print-${k}-${o.order_number}`} href={`/admin/print/${o.order_number}?doc=${k}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[0.6rem] tracking-[0.15em] uppercase border border-[var(--mm-line)] px-2 py-1.5 hover:border-[var(--mm-red)] hover:text-[var(--mm-red)]"><Printer size={11} />{l}</a>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
